import { render, staticRenderFns } from "./ConDirectDeanListManagement.vue?vue&type=template&id=b40fb934&"
import script from "./ConDirectDeanListManagement.vue?vue&type=script&lang=js&"
export * from "./ConDirectDeanListManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConDirectDeanListManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports